import { render, staticRenderFns } from "./AssignmentDutiesPage.vue?vue&type=template&id=6088d05b"
import script from "./AssignmentDutiesPage.vue?vue&type=script&lang=js"
export * from "./AssignmentDutiesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports